<section class="column-gap-1 vertical-container-simple">
    <app-fund-strategy-selector
        data-qa="fs-model-selector"
        [data]="fsModels"
        [selectedItem]="selectedModel"
        [organization]="selectedOrganization"
        [buttons]="buttonsProps"
        (buttonClicked)="buttonClicked($event)"
        (selectedItemChanged)="selectedModelChanged($event)"
        (exportExcelEmitter)="exportExcel()"
        (inputChanged)="modelName = $event">
    </app-fund-strategy-selector>
    <div class="flex flex-col gap-0.9375">
      <div class="flex gap-0.9375">
        <app-fund-strategy-fund-metrics *ngIf="metrics" class="main w-full" [isModelBlocked]="isModelBlocked"  [metricsData]="metrics" (inputsSaveEmitter)="saveMetrics($event)"/>
        <app-fund-strategy-portfolio-metrics class="main w-full" [fsGroups]="groupsFS" [isModelBlocked]="isModelBlocked" (totalsEmitter)="collectMetricsData($event)"/>
      </div>
      <div class="main">
          <app-fund-strategy-table
              class="green-scroll"
              [saveModel]="buttonsProps.apply"
              [isModelBlocked]="isModelBlocked"
              [modelName]="selectedModel?.name"
              [groups]="selectedModel?.groups"
              [metricsData]="metrics"
              (exportExcelEmitter)="saveDataForExportExcel($event)"
              (updateModelEmitter)="handleSaveGroups($event)">
          </app-fund-strategy-table>
      </div>
    </div>
</section>
